/** Server reason when the trial guard could not read billing and refused (fail closed). Not
 *  "already used": say the trial isn't available right now, and still offer the plans. */
const CHECK_FAILED_REASON = 'eligibility_check_failed';

/** What a `start-pro-trial` answer means for the wizard. 'used' = this workspace or this email
 *  already had a subscription — offer the paid plan, never a dead end. 'unavailable' = the check
 *  itself failed — same paid-plan offer, neutral wording. */
export function trialOutcome(res: { ok?: boolean; ineligible?: boolean; reason?: string } | null | undefined): 'started' | 'used' | 'unavailable' | 'error' {
  if (res?.ok) return 'started';
  if (res?.ineligible) return res.reason === CHECK_FAILED_REASON ? 'unavailable' : 'used';
  return 'error';
}

/** #691: the `pro-trial-eligibility` answer, asked before the wizard offers a trial. Only an explicit
 *  `eligible: false` hides the trial: a missing/odd answer (older backend, network error) keeps the
 *  offer, and the server still refuses a repeat trial on click. */
export function eligibilityTrialState(res: { eligible?: unknown; reason?: unknown } | null | undefined): 'idle' | 'used' | 'unavailable' {
  if (res?.eligible !== false) return 'idle';
  return res.reason === CHECK_FAILED_REASON ? 'unavailable' : 'used';
}
